import { PageHolder, PageContent } from "./ScoodleDefaultPage.Styled";
import { InformatFooter } from "../../../03organisms/informat/footer/InformatFooter";
import { InformatHeader } from "../../../03organisms/informat/header/InformatHeader";
import { ZendeskHelp } from "pu-crossproduct-components/build/components/Organisms/Widgets/ZendeskHelp";

export const ScoodleDefaultPage: React.FC = props => {
    return <PageHolder>
        <PageContent>{props.children}</PageContent>

        <ZendeskHelp widgetKey="a097f55f-d153-44cf-a772-93ecbce576f2" zendeskSettings={{
            "webWidget": {
                "helpCenter": {
                    "filter": {
                        "category": "115000733049"
                    }
                }
            }
        }} />
    </PageHolder>
}
